import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

export default function PpiListSearch({ onChangeInput }) {
  const [userInput, setUserInput] = useState('');

  function onChangehandler(e) {
    e.preventDefault();
    const data = e.target.value;
    // setUserInput(data.trim().toLowerCase());
    setUserInput(data);
    const result = data.trim().toLowerCase();
    if (result.length >= 0) {
      const delayDebounceFn = setTimeout(() => {
        onChangeInput(result);
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    }
  }

  const keyPressHandler = e => {
    if (e.keyCode == 13) {
      e.preventDefault();
    }
  };

  return (
    <Paper
      component="form"
      sx={{ p: '4px 6px 2px', display: 'flex', alignItems: 'space-between' }}
    >
      <InputBase
        style={{ width: '290px', paddingLeft: '10px', height: '25px' }}
        placeholder="Search by ingredient name"
        inputProps={{ 'aria-label': 'Search by ingredient name' }}
        value={userInput}
        onKeyDown={keyPressHandler}
        onChange={e => onChangehandler(e)}
      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
